import { render, staticRenderFns } from "./ChooseRolePage.vue?vue&type=template&id=494be39e&scoped=true"
import script from "./ChooseRolePage.vue?vue&type=script&lang=js"
export * from "./ChooseRolePage.vue?vue&type=script&lang=js"
import style0 from "./ChooseRolePage.vue?vue&type=style&index=0&id=494be39e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494be39e",
  null
  
)

export default component.exports